import Lottie from "lottie-react";
import PageLayout from "../components/PageLayout";
import radar from "../assets/lottie/radar.json";

function NotFound() {
  return (
    <PageLayout title="404" className="not-found-page-container">
      <div className="not-found-content container">
        <div className="row">
          <div className="col-12 fade-in">
            <div className="not-found-animation">
              <Lottie animationData={radar} loop autoplay />
            </div>
            <p className="subtle">
              The page you're looking for doesn't exist or may have moved.
            </p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default NotFound;
